"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _printableWorksheets = require("printableWorksheets");
var _CircleLoader = _interopRequireDefault(require("printableWorksheets/atoms/CircleLoader/CircleLoader"));
var _state = require("printableWorksheets/state");
var _react = _interopRequireWildcard(require("react"));
var _worksheetsNotFound = _interopRequireDefault(require("../../../teacherDashboard/teacher/components/printable_worksheets/worksheets-not-found"));
var _worksheetsNav = _interopRequireDefault(require("../worksheetsNav"));
var _worksheetsView = _interopRequireDefault(require("../worksheetsView"));
var _wsTeacherHeader = _interopRequireDefault(require("../worksheetsView/wsTeacherHeader"));
require("./styles.scss");
var _events = _interopRequireDefault(require("printableWorksheets/events"));
var _common = require("apps/teacher/config/common");
var _utils = require("../../../teacherDashboardIA/utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectDestructuringEmpty(t) { if (null == t) throw new TypeError("Cannot destructure " + t); }
var Printables = function Printables(_ref) {
  _objectDestructuringEmpty(_ref);
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    defaultSearch = _usePrintableWorkshee.defaultSearch,
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment,
    isWorksheetsLoading = _usePrintableWorkshee.isWorksheetsLoading,
    ineligibleGrade = _usePrintableWorkshee.ineligibleGrade,
    activeGrade = _usePrintableWorkshee.activeGrade;
  var isTeacherEnvironment = (0, _react.useMemo)(function () {
    return worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD;
  }, [worksheetsEnvironment]);
  var renderTeacherEnvironment = (0, _react.useMemo)(function () {
    if (ineligibleGrade) {
      return /*#__PURE__*/_react["default"].createElement(_worksheetsNotFound["default"], null);
    } else {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "printable-worksheets__top".concat(!defaultSearch ? ' un-focus' : '')
      }, /*#__PURE__*/_react["default"].createElement(_wsTeacherHeader["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "printable-worksheets__bottom"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "printable-worksheets__left".concat(!defaultSearch ? ' un-focus' : '')
      }, /*#__PURE__*/_react["default"].createElement(_worksheetsNav["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "printable-worksheets__right"
      }, /*#__PURE__*/_react["default"].createElement(_worksheetsView["default"], null))));
    }
  }, [ineligibleGrade]);
  (0, _react.useEffect)(function () {
    _events["default"].viewedWorksheetListingPage({
      fromPage: (0, _utils.getFromPage)(),
      worksheetGrade: activeGrade,
      freeWorksheetsLeftCount: (0, _common.freeWsDownloadLeft)()
    });
  }, []);
  var toRender = (0, _react.useMemo)(function () {
    return isWorksheetsLoading ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "ws-loader-container"
    }, /*#__PURE__*/_react["default"].createElement(_CircleLoader["default"], null)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isTeacherEnvironment ? renderTeacherEnvironment : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "printable-worksheets__left".concat(!defaultSearch ? ' un-focus' : '')
    }, /*#__PURE__*/_react["default"].createElement(_worksheetsNav["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "printable-worksheets__right student-env",
      id: "ws-right-div"
    }, /*#__PURE__*/_react["default"].createElement(_worksheetsView["default"], null))));
  }, [isWorksheetsLoading, isTeacherEnvironment]);
  return toRender;
};
var _default = exports["default"] = Printables;